<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/new_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go-back-link')"
    name="ae_production_basic_container_export_show_process_containers_path"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <agro-exporter-process-header
    :agro_exporter_process_id="agro_exporter_process_id"
  />

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('container_code')]">
                {{ $t("model.container.container_code") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="container_code"
                  :class="['input-text', isInvalid('container_code')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.customer") }}
              </label>
              <div class="mt-1">
                <select-form
                  v-if="customers.length > 0"
                  :options="customers"
                  v-model="customer_id"
                />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('status_id')]">
                {{ $t("model.container.status") }}
              </label>
              <div class="mt-1">
                <container-status-selector v-model="status_id" />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.exportation") }}
              </label>
              <div class="mt-1">
                <select-form
                  v-if="available_exportations.length > 0"
                  :options="available_exportations"
                  v-model="exportation_id"
                  label="booking_code"
                />
                <alert-warning
                  v-else
                  :warning_data="{
                    title: $t('labels.not_available_exportations')
                  }"
                />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div
              class="sm:col-span-3"
              v-if="producers_organizations.length > 0"
            >
              <label class="label-form">
                {{ $t("model.container.provider") }}
              </label>
              <div class="mt-1" v-if="producers_organizations.length > 1">
                <ProducerOrOrganizationSelect
                  :options="producers_organizations"
                  v-model:producer_id="provider_producer_id"
                  v-model:organization_id="provider_organization_id"
                />
              </div>
              <div
                class="content-data mt-1"
                v-else-if="producers_organizations.length == 1"
              >
                {{ producers_organizations[0].label }}
              </div>
            </div>
          </div>
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div
              class="sm:col-span-3"
              v-if="packing_house_processes.length > 0"
            >
              <label class="label-form">
                {{ $t("model.container.packing_house_process") }}
              </label>
              <div class="mt-1">
                <select-form
                  v-if="packing_house_processes.length > 1"
                  :options="packing_house_processes"
                  v-model="packing_house_process_id"
                />
                <div
                  class="content-data"
                  v-else-if="packing_house_processes.length == 1"
                >
                  {{ packing_house_processes[0].name }}
                </div>
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.load_date") }}
              </label>
              <div class="mt-1">
                <date-form v-model="load_date" />
              </div>
            </div>
          </div>
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.waybill") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="waybill"
                  :class="['input-text', isInvalid('waybill')]"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.exporter_process_brand") }}
              </label>
              <div class="mt-1 grid grid-cols-1 sm:grid-cols-8">
                <div class="sm:col-span-2">
                  <dt class="mt-1">
                    <SwitchGroup as="div" class="flex items-center">
                      <Switch
                        v-model="fixed_brand"
                        :class="[
                          fixed_brand ? 'bg-lime-600' : 'bg-gray-200',
                          'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                        ]"
                      >
                        <span
                          aria-hidden="true"
                          :class="[
                            fixed_brand ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                          ]"
                        />
                      </Switch>
                      <SwitchLabel as="span" class="ml-3">
                        <span class="label-form">
                          {{ $t("model.container.fixed_brand") }}
                        </span>
                      </SwitchLabel>
                    </SwitchGroup>
                  </dt>
                </div>
                <div class="sm:col-span-6" v-show="fixed_brand">
                  <select-form
                    v-if="brands.length > 1"
                    :options="brands"
                    v-model="brand"
                  />
                  <div class="content-data" v-else-if="brands.length == 1">
                    {{ brands[0].name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.cols_package_groups") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="cols"
                  :class="['input-text', isInvalid('cols')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.rows_package_groups") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="rows"
                  :class="['input-text', isInvalid('rows')]"
                />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.container.private_comments") }}
                <em class="text-sm text-green-800 bg-green-100 p-1 rounded-md">
                  {{ $t("model.container.describe_private_comments") }}
                </em>
              </label>
              <div class="mt-1">
                <textarea
                  v-model="private_comments"
                  rows="3"
                  :class="['input-text-area', isInvalid('private_comments')]"
                />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <switch-form
              class="sm:col-span-6"
              v-model="add_comment"
              :label="$t('labels.add_comment_label')"
            />
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.container.comments") }}
                <em class="text-sm text-red-800 bg-red-100 p-1 rounded-md">
                  {{ $t("model.container.describe_comments") }}
                </em>
              </label>
              <div class="mt-1">
                <textarea
                  :disabled="!add_comment"
                  v-model="comments"
                  rows="3"
                  :class="[
                    'input-text-area',
                    isInvalid('comments'),
                    add_comment ? '' : 'bg-gray-100'
                  ]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowProcess()"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="createContainer()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import moment from "moment";
import BasicContainerExportQRequester from "@/views/agro_exporter/requesters/production/basic_container_export/query.js";
import BasicContainerExportMCRequester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_container.js";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import AgroExporterProcessHeader from "@/components/views/agro_exporter/production/basic_container_export/AgroExporterProcessHeader.vue";
import ContainerStatusSelector from "@/components/views/agro_exporter/production/basic_container_export/ContainerStatusSelector.vue";
import ProducerOrOrganizationSelect from "@/components/views/agro_exporter/production/basic_container_export/ProducerOrOrganizationSelect.vue";

export default {
  name: "AEProductionBasicContainerExportNewContainer",
  components: {
    AgroExporterProcessHeader,
    ContainerStatusSelector,
    Switch,
    SwitchGroup,
    SwitchLabel,
    ProducerOrOrganizationSelect
  },
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      available_exportations: [],
      container_statuses: [],
      exportation_id: null,
      container_code: null,
      customer_id: null,
      customers: [],
      packing_house_processes: [],
      packing_house_process_id: null,
      load_date: null,
      waybill: null,
      fixed_brand: true,
      brand: null,
      brands: [],
      cols: 2,
      rows: 11,
      comments: null,
      status_id: null,
      private_comments: null,
      add_comment: false,
      producers_organizations: [],
      provider_producer: {},
      provider_producer_id: null,
      provider_organization: {},
      provider_organization_id: null
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchAvailableExportations();
      await this.fetchCustomers();
      await this.fetchExporterProcessBrands();
      await this.fetchPackingHouseProcesses();
      await this.fetchProducersOrganizations();
      this.load_general_data = true;
    },
    fetchAvailableExportations: async function () {
      let response =
        await BasicContainerExportMCRequester.fetchAvailableToAssignExportations(
          this.agro_exporter_process_id
        );
      this.available_exportations = response.data;
    },
    fetchCustomers: async function () {
      let response = await BasicContainerExportQRequester.fetchCustomers(
        this.agro_exporter_process_id
      );
      this.customers = response.data;
    },
    fetchExporterProcessBrands: async function () {
      let response =
        await BasicContainerExportQRequester.fetchExporterProcessBrands(
          this.agro_exporter_process_id
        );
      this.brands = response.data;
      if (this.brands.length == 1) this.brand = this.brands[0].id;
    },
    fetchPackingHouseProcesses: async function () {
      let response =
        await BasicContainerExportQRequester.fetchPackingHouseProcesses(
          this.agro_exporter_process_id
        );
      this.packing_house_processes = response.data;
      if (this.packing_house_processes.length == 1)
        this.packing_house_process_id = this.packing_house_processes[0].id;
    },
    fetchContainerStatuses: async function () {
      let response =
        await BasicContainerExportQRequester.fetchContainerStatuses(
          this.agro_exporter_process_id
        );
      this.container_statuses = response.data;
    },
    fetchProducersOrganizations: async function () {
      let response =
        await BasicContainerExportQRequester.fetchProducersOrganizations(
          this.agro_exporter_process_id
        );
      this.producers_organizations = response.data;
      if (this.producers_organizations.length == 1) {
        this.provider_producer_id = this.producers_organizations[0].producer_id;
        this.provider_organization_id =
          this.producers_organizations[0].organization_id;
      }
    },
    createContainer: async function () {
      this.proc_save_button = true;
      try {
        let response = await BasicContainerExportMCRequester.createContainer(
          this.agro_exporter_process_id,
          {
            exportation_id: this.exportation_id,
            container_code: this.container_code,
            customer_id: this.customer_id,
            load_date: this.load_date_formatted,
            packing_house_process_id: this.packing_house_process_id,
            waybill: this.waybill,
            fixed_brand: this.fixed_brand,
            exporter_process_brand_id: this.fixed_brand ? this.brand : null,
            cols_package_groups: this.cols,
            rows_package_groups: this.rows,
            comments: this.comments,
            status_id: this.status_id,
            private_comments: this.private_comments,
            provider_producer_id: this.provider_producer_id,
            provider_organization_id: this.provider_organization_id
          }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },
    goToShowProcess: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_show_process_containers_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    },
    filterPackingHouseProcessByProvider: function (entity, provider_id) {
      return this.packing_house_processes.filter(
        packing_house_process =>
          packing_house_process.entity_id ==
          this.producers_organizations.find(
            producer_organization =>
              producer_organization[entity] == provider_id
          ).entity_id
      );
    }
  },
  computed: {
    load_date_formatted: function () {
      return moment(this.load_date).format("YYYY-MM-DD");
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchData())
    );
  },
  watch: {
    add_comment: function () {
      this.comments = null;
    },
    provider_producer_id: function () {
      let packing_house_processes = this.filterPackingHouseProcessByProvider(
        "producer_id",
        this.provider_producer_id
      );
      if (packing_house_processes.length > 0)
        this.packing_house_process_id = packing_house_processes[0].id;
    },
    provider_organization_id: function () {
      let packing_house_processes = this.filterPackingHouseProcessByProvider(
        "organization_id",
        this.provider_organization_id
      );
      if (packing_house_processes.length > 0)
        this.packing_house_process_id = packing_house_processes[0].id;
    }
  }
};
</script>
